module.exports = __webpack_public_path__ + "static/media/sonali_chakravorty.56676501.jpeg";